import { useCurrentSpaceContext } from "@circle-react/contexts/currentSpaceContext";
import { useCurrentCommunityMember } from "@circle-react/contexts/punditUserContext";
import { postInvalidations } from "@circle-react/lib/queries/posts";
import { useCallback } from "react";

import { useInvalidatePostsApiQueries } from "@/react/components/SettingsApp/Posts/hooks/usePostsApi";

export const useCreatePostModalInvalidations = () => {
  const { data: space } = useCurrentSpaceContext();
  const currentMember = useCurrentCommunityMember();
  const { invalidatePostsApiQueries } = useInvalidatePostsApiQueries();

  return useCallback(
    async (postId: number) => {
      if (space?.id) void postInvalidations.spacePosts(space.id);
      void postInvalidations.feedPosts();
      if (currentMember?.public_uid)
        void postInvalidations.profilePosts(currentMember.public_uid);
      await postInvalidations.postDetails(postId);
      await invalidatePostsApiQueries();
    },
    [space?.id, currentMember?.public_uid, invalidatePostsApiQueries],
  );
};
